import { createFileRoute } from '@tanstack/react-router'
import { useMsal } from '@azure/msal-react'
import { Typography, Box, Paper, Avatar } from '@mui/material'
import { getDisplayName, getEmployeeEmail } from '@/auth/authHelpers'

export const Route = createFileRoute('/_authenticated/profile')({
  component: ProfilePage,
})

function ProfilePage() {
  const { accounts } = useMsal()
  const account = accounts[0] ?? null
  const name = getDisplayName(account)
  const email = getEmployeeEmail(account)

  return (
    <Box>
      <Typography variant="h4" gutterBottom>
        Mijn profiel
      </Typography>
      <Paper variant="outlined" sx={{ p: 3, maxWidth: 480 }}>
        <Avatar sx={{ width: 64, height: 64, mb: 2, bgcolor: 'primary.main' }}>
          {name.charAt(0).toUpperCase()}
        </Avatar>
        <Typography variant="h6">{name}</Typography>
        <Typography variant="body2" color="text.secondary">
          {email}
        </Typography>
        <Typography
          variant="caption"
          color="text.disabled"
          sx={{ mt: 2, display: 'block' }}
        >
          Hier komt binnenkort meer te staan. We zijn er mee bezig!
        </Typography>
      </Paper>
    </Box>
  )
}
